import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

// Script para verificar que las colecciones de Firebase estén creadas
export const verifyFirebaseCollections = async () => {
  console.log('🔍 Verificando colecciones de Firebase...');
  
  try {
    const collections = {
      categories: 'categories',
      wineries: 'wineries', 
      types: 'types',
      wines: 'wines'
    };

    const results = {};

    // Verificar cada colección
    for (const [name, collectionName] of Object.entries(collections)) {
      try {
        const snapshot = await getDocs(collection(db, collectionName));
        results[name] = {
          exists: true,
          count: snapshot.size,
          documents: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        };
        console.log(`✅ ${name}: ${snapshot.size} documentos`);
      } catch (error) {
        results[name] = {
          exists: false,
          error: error.message
        };
        console.log(`❌ ${name}: Error - ${error.message}`);
      }
    }

    // Resumen
    const totalDocs = Object.values(results)
      .filter(r => r.exists)
      .reduce((sum, r) => sum + r.count, 0);

    console.log('\n📊 RESUMEN DE FIREBASE:');
    console.log(`Total documentos: ${totalDocs}`);
    console.log('Detalles por colección:');
    
    Object.entries(results).forEach(([name, data]) => {
      if (data.exists) {
        console.log(`  • ${name}: ${data.count} docs`);
      } else {
        console.log(`  • ${name}: ERROR - ${data.error}`);
      }
    });

    if (totalDocs > 0) {
      console.log('\n🎉 ¡Firebase está funcionando correctamente!');
    } else {
      console.log('\n⚠️  No se encontraron documentos en Firebase');
    }

    return results;

  } catch (error) {
    console.error('❌ Error verificando Firebase:', error);
    throw error;
  }
};

// Función para ejecutar desde la consola del navegador
window.verifyFirebase = verifyFirebaseCollections;

export default verifyFirebaseCollections; 